















































import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable
  }
})
export default class DraggableList extends Vue {
  // Props
  @Prop(String) public label!: string;
  @Prop(Array) public list!: string[];
  @Prop(Boolean) public isReadOnly!: boolean;
  public version = 1;

  public addItem() {
    this.list.push('');
    this.$emit('change', this.list);
    this.$emit('add', this.list);
  }
  public deleteItem(index) {
    this.list.splice(index, 1);
    this.version += 1;
    this.$emit('change', this.list);
  }
}
